/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react'
import {useDispatch} from "react-redux";
import {SET_CONFIRM, SET_ERROR} from "../../../Redux/Actions/Types";

export function StreamBankErrorDispatchEnhance(ComposedComponent) {
	return (props) => {
		const dispatch = useDispatch();

		const setAlert = (message, title) => {
			dispatch({
				type: SET_CONFIRM,
				confirm: {
					title: title ?? "StreamBank",
					message: message,
				}
			});
		}

		const setError = (error) => {
			dispatch({type: SET_ERROR, error: error});
		}

		const defaultErrorHandler = (error) => {
			if (error?.xhr) {
				setError({
					Code: error?.xhr?.status,
					Message: error?.message,
					Title: error?.xhr?.statusText,
					StackTrace: error?.data?.stackTrace
				});
			} else if (error instanceof Error) {
				throw error;
			}
		}

		const getStackTrace = () => {
			let obj = {};
			Error.captureStackTrace(obj, getStackTrace);
			return obj.stack;
		}


		const showPermissionDenied = () => {
			dispatch({
				type: SET_ERROR,
				error: {
					Code: 403,
					Message: 'Permission Denied',
					Title: 'Forbidden',
				}
			});
		}


		return <ComposedComponent
			{...props}

			ErrorDispatch={{
				ShowAlert: setAlert,
				SetError: setError,
				DefaultHandler: defaultErrorHandler,
				GetStackTrace: getStackTrace,
				ShowPermissionDenied: showPermissionDenied
			}}

		/>;
	}
}


